import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["placeholder"];
import { TUITranslateService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import TUICore, { TUIConstants } from "@tencentcloud/tui-core";
import { isPC } from "../../../utils/env";
import { TUIGlobal } from "../../../utils/universal-api/index";
import Icon from "../../common/Icon.vue";
import addSVG from "../../../assets/icon/add.svg";
import backSVG from "../../../assets/icon/back.svg";
import { ref, watch } from "../../../adapter-vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var searchingPlaceholder = TUITranslateService.t('TUIContact.输入ID');
    var isSearching = ref(false);
    var searchValue = ref("");
    var searchResult = ref({
      user: {
        label: "联系人",
        list: []
      },
      group: {
        label: "群聊",
        list: []
      }
    });
    var handleSearchingHeaderClicked = function handleSearchingHeaderClicked() {
      if (!isSearching.value) {
        isSearching.value = true;
      }
    };
    var handleSearchingIconClicked = function handleSearchingIconClicked() {
      isSearching.value = !isSearching.value;
    };
    var search = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (searchValue.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              TUICore.callService({
                serviceName: TUIConstants.TUISearch.SERVICE.NAME,
                method: TUIConstants.TUISearch.SERVICE.METHOD.SEARCH_USER,
                params: {
                  userID: searchValue.value
                }
              }).then(function (res) {
                searchResult.value.user.list = res.data;
              })["catch"](function (error) {
                searchResult.value.user.list = [];
                console.warn("search user error", error);
              });
              TUICore.callService({
                serviceName: TUIConstants.TUISearch.SERVICE.NAME,
                method: TUIConstants.TUISearch.SERVICE.METHOD.SEARCH_GROUP,
                params: {
                  groupID: searchValue.value
                }
              }).then(function (res) {
                searchResult.value.group.list = [res.data.group];
              })["catch"](function (error) {
                searchResult.value.group.list = [];
                console.warn("search group error", error);
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function search() {
        return _ref.apply(this, arguments);
      };
    }();
    watch(function () {
      return searchResult.value;
    }, function () {
      TUIStore.update(StoreName.CUSTOM, "currentContactSearchResult", searchResult.value);
    }, {
      deep: true,
      immediate: true
    });
    watch(function () {
      return isSearching.value;
    }, function () {
      TUIStore.update(StoreName.CUSTOM, "currentContactSearchingStatus", isSearching.value);
      if (isSearching.value) {
        searchValue.value = "";
        searchResult.value.user.list = [];
        searchResult.value.group.list = [];
      }
    }, {
      deep: true,
      immediate: true
    });
    // 全局公共方法
    TUIGlobal.updateContactSearch = search;
    TUIGlobal.closeSearching = function () {
      isSearching.value = false;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['TUI-contact-search', !_unref(isPC) && 'TUI-contact-search-h5'])
      }, [!_unref(isSearching) || !_unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['TUI-contact-search-header', !_unref(isPC) && 'TUI-contact-search-h5-header', _unref(isSearching) && 'TUI-contact-searching-h5-header']),
        onClick: handleSearchingHeaderClicked
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-search-header-icon', !_unref(isPC) && 'TUI-contact-search-h5-header-icon']),
        onClick: _withModifiers(handleSearchingIconClicked, ["stop"])
      }, [_createVNode(Icon, {
        file: _unref(isSearching) ? _unref(backSVG) : _unref(addSVG),
        width: _unref(isSearching) ? '20px' : '14px',
        height: _unref(isSearching) ? '20px' : '14px'
      }, null, 8, ["file", "width", "height"])], 2), _createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-search-header-title', !_unref(isPC) && 'TUI-contact-search-h5-header-title'])
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.添加好友/群聊")), 3)], 2)) : _createCommentVNode("", true), _unref(isSearching) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['TUI-contact-search-main', !_unref(isPC) && 'TUI-contact-search-h5-main'])
      }, [_withDirectives(_createElementVNode("input", {
        "class": "TUI-contact-search-main-input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(searchValue) ? searchValue.value = $event : null;
        }),
        placeholder: _unref(searchingPlaceholder),
        onKeyup: _withKeys(search, ["enter"]),
        onBlur: search,
        onConfirm: search,
        enterkeyhint: "search"
      }, null, 40, _hoisted_1), [[_vModelText, _unref(searchValue)]]), _createElementVNode("div", {
        "class": "TUI-contact-search-main-cancel",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return isSearching.value = false;
        })
      }, _toDisplayString(_unref(TUITranslateService).t("取消")), 1)], 2)) : _createCommentVNode("", true)], 2);
    };
  }
});